function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(88,50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 1
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.9285714285714286s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.9285714285714286s"
}))));
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(84.23681698029193,66.48758208646721)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(25.714285714285715)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 0.9285714285714286
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.8571428571428571s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.8571428571428571s"
}))));
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(73.69261247063187,79.70959633378513)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(51.42857142857143)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 0.8571428571428571
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.7857142857142857s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.7857142857142857s"
}))));
var _ref5 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(58.45579549033995,87.0472606629093)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(77.14285714285715)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 0.7857142857142857
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.7142857142857143s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.7142857142857143s"
}))));
var _ref6 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(41.544204509660055,87.0472606629093)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(102.85714285714286)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 0.7142857142857143
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.6428571428571429s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.6428571428571429s"
}))));
var _ref7 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(26.30738752936813,79.70959633378513)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(128.57142857142856)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 0.6428571428571429
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.5714285714285714s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.5714285714285714s"
}))));
var _ref8 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(15.76318301970808,66.48758208646721)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(154.2857142857143)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 0.5714285714285714
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.5s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.5s"
}))));
var _ref9 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(12,50.00000000000001)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 0.5
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.42857142857142855s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.42857142857142855s"
}))));
var _ref10 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(15.763183019708073,33.5124179135328)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(205.71428571428572)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 0.42857142857142855
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.35714285714285715s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.35714285714285715s"
}))));
var _ref11 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(26.307387529368118,20.29040366621487)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(231.42857142857142)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 0.35714285714285715
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.2857142857142857s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.2857142857142857s"
}))));
var _ref12 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(41.54420450966005,12.952739337090705)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(257.1428571428571)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 0.2857142857142857
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.21428571428571427s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.21428571428571427s"
}))));
var _ref13 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(58.45579549033991,12.95273933709069)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(282.85714285714283)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 0.21428571428571427
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.14285714285714285s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.14285714285714285s"
}))));
var _ref14 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(73.69261247063187,20.290403666214864)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(308.5714285714286)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 0.14285714285714285
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.07142857142857142s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.07142857142857142s"
}))));
var _ref15 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(84.23681698029193,33.512417913532815)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(334.2857142857144)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "rgba(85, 95, 194, 0.41612903225806464)",
  fillOpacity: 0.07142857142857142
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "0s",
  values: "1.55 1.55;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "0s"
}))));
const SvgSpin1S18Px = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      margin: "auto",
      background: "none",
      display: "inline",
      shapeRendering: "auto"
    },
    width: "30px",
    height: "30px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpin1S18Px, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Spin-1s-18px.6d03c67d.svg";
export { ForwardRef as ReactComponent };